import { SpaceType } from 'src/components/SearchBar/types'
import { PillarPage } from 'src/constants/searchPages'

/**
 * Soluciones Logísticas (3PL) search-card gate. Mirrors the SHAPE of
 * `shouldShowOnDemandSearchCard` (SearchList.tsx) — same "URL pillar OR
 * FilterProvider space-type filter" recognition — but with NO coverage gate.
 *
 * On-demand (Almacenamiento a Domicilio) is a physical fulfillment product
 * tied to a partner operating in specific metros, so it gates on
 * `resolveOnDemandCity(...).partnerActive`. 3PL is the opposite: it's a
 * capture-first discovery surface (`/soluciones-logisticas`) that connects
 * the renter with a specialist who sources 3PL operators nationwide — there
 * is no per-city partner roster to check against. Showing it everywhere a
 * B2B-pillar search happens is the intended behavior, not a gap.
 *
 * Shows on B2B-pillar searches:
 *  - by URL (`renta-bodegas-comerciales` / `renta-naves-industriales`)
 *  - by space-type filter recognition on generic `/search` (no URL pillar)
 *    when the user has WAREHOUSE or INDUSTRIAL_WAREHOUSE selected
 *
 * Hides on self-storage (URL or filter) and on generic search with no B2B
 * space-type selected.
 */
export function shouldShowLogisticsCard(
  routerPillar: string | string[] | undefined,
  filterSpaceTypes?: SpaceType[]
): boolean {
  const pillar = Array.isArray(routerPillar) ? routerPillar[0] : routerPillar

  if (pillar === PillarPage.Warehouse || pillar === PillarPage.Industrial) {
    return true
  }
  if (pillar) return false

  if (!Array.isArray(filterSpaceTypes)) return false
  return (
    filterSpaceTypes.includes(SpaceType.WAREHOUSE) ||
    filterSpaceTypes.includes(SpaceType.INDUSTRIAL_WAREHOUSE)
  )
}
